import React, { useEffect, useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { API_config } from '../../config/apiConfig';

const getIconForType = (type, sequence) => {
    let color = '#9ca3af'; // Other -> grey
    if (type === 'Safety') color = '#f97316'; // orange
    if (type === 'Marshal') color = '#ef4444'; // red
    if (type === 'Police') color = '#3b82f6'; // blue
    
    const text = sequence != null ? sequence : '';
    
    return L.divIcon({
        className: 'custom-safety-marker-main',
        html: `<div style="background-color: ${color}; width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 11px;">${text}</div>`,
        iconSize: [22, 22],
        iconAnchor: [11, 11],
    });
};

const SafetyPointsLayer = ({ stageId }) => {
    const [points, setPoints] = useState([]);

    useEffect(() => {
        const fetchPoints = async () => {
            try {
                const token = localStorage.getItem('token') || API_config.bearerToken;
                const res = await fetch(API_config.safetyPointsApiUrl, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const data = await res.json();
                    setPoints(data || []);
                }
            } catch (error) {
                console.error('Failed to load safety points', error);
            }
        };
        fetchPoints();
    }, []); // Only fetch once on mount

    if (!stageId) return null;

    // Filter points matching the currently selected stage ID
    const visiblePoints = points.filter(p => p.stage_id && p.stage_id.toString() === stageId.toString());

    return (
        <>
            {visiblePoints.map(point => (
                <Marker
                    key={point.id}
                    position={[point.latitude, point.longitude]}
                    icon={getIconForType(point.type, point.position_sequence)}
                >
                    <Popup>
                        <div style={{minWidth: '150px'}}>
                            <strong>{point.name}</strong><br />
                            {point.description && <em style={{fontSize:'12px', display:'block', marginBottom:'4px'}}>{point.description}</em>}
                            {point.contact_phone && <span>📞 {point.contact_phone}<br /></span>}
                            <span style={{textTransform: 'capitalize', fontWeight: 'bold'}}>{point.type}</span>
                            {point.position_sequence ? ` (Seq: ${point.position_sequence})` : ''}
                        </div>
                    </Popup>
                </Marker>
            ))}
        </>
    );
};

export default SafetyPointsLayer;
